import React from "react";
import { ReactSVG } from "react-svg";
import { basic_icons } from "./icon_svg/basic";
import { purpose_icons } from "./icon_svg/purpose";

const icons = { ...basic_icons, ...purpose_icons };
export type IconNames = keyof typeof icons;

type IconProps = {
    name: IconNames;
    size?: number;
    color?: string;
    style?: React.CSSProperties;
};

const IconV2 = (prop: IconProps) => {
    const { name, size = 24, color = "#ffffff", style } = prop;
    const IconComponent = icons[name];

    if (!IconComponent) {
        return null;
    }

    return (
        <ReactSVG
            src={IconComponent}
            beforeInjection={(svg) => {
                svg.setAttribute("width", size.toString());
                svg.setAttribute("height", size.toString());
                const paths = svg.querySelectorAll("path");
                paths.forEach((path) => {
                    path.setAttribute("fill", color);
                });
            }}
            style={style}
        />
    );
};

export default IconV2;
